import type { ReactNode } from 'react';
import { ScrollView } from 'react-native';
import { type StackProps, YStack } from 'smoothie';

interface PreviewContainerProps extends StackProps {
    children: ReactNode;
}

export const PreviewContainer = ({
    children,
    ...stackProps
}: PreviewContainerProps) => {
    return (
        <YStack
            flex={1}
            flexBasis={0}
            borderRightWidth={1}
            borderRightColor="$gray500"
            {...stackProps}
        >
            <ScrollView
                style={{
                    flex: 1,
                    padding: 16,
                }}
            >
                {children}
            </ScrollView>
        </YStack>
    );
};
